export interface ApplicantsState {
  isLoading: boolean | null;
};
export const initialState = {
  isLoading: null
};